import Footer from "../../components/common/footer";
import Offer1MulczerLesny from "../../components/offer/1mulczerLesny";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Mulczowanie działek pod budowę i mulczer leśny | Gdańsk, Wejherowo, Kaszuby</title>
        <meta name="title" content="Mulczowanie działek pod budowę i mulczer leśny | Gdańsk, Wejherowo, Kaszuby" />
        <meta
          name="description"
          content="Maszynowe czyszczenie i mulczowanie działek z zarośli i samosiejek mulczerem leśnym. Szybkie przygotowanie terenu pod budowę w Gdańsku, Gdyni, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Mulczowanie działek pod budowę i mulczer leśny | Gdańsk, Wejherowo, Kaszuby"
        />
        <meta
          property="og:description"
          content="Maszynowe czyszczenie i mulczowanie działek z zarośli i samosiejek mulczerem leśnym. Szybkie przygotowanie terenu pod budowę w Gdańsku, Gdyni, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1MulczerLesny />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
